import { h } from 'preact';
export const ArrowUp = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("line", { x1: "12", y1: "19", x2: "12", y2: "5" }),
        h("polyline", { points: "5 12 12 5 19 12" })));
};
//# sourceMappingURL=arrow-up.js.map